import { render, staticRenderFns } from "./RegisterSuccesModal.vue?vue&type=template&id=3fc6afde&"
import script from "./RegisterSuccesModal.vue?vue&type=script&lang=js&"
export * from "./RegisterSuccesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports